// Generated types for Industry
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI, NeoNodeWriteAPI } from '../../shared/types/neonode';
import { NeoNodeReadAPISchemaObject, NeoNodeWriteAPISchemaObject } from '../../shared/types/neonode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface IndustryReadAPI extends NeoNodeReadAPI {
  /** The industry a product belongs to.
        If many industries apply, choose the one with the narrowest scope fitting the product. */
  name?: string;
}

export interface IndustryWriteAPI extends NeoNodeWriteAPI {
  /** The industry a product belongs to.
        If many industries apply, choose the one with the narrowest scope fitting the product. */
  name?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const IndustryReadAPISchema: z.ZodType<IndustryReadAPI> = NeoNodeReadAPISchemaObject.extend({
  name: z.string().optional(),
}).passthrough();

export const IndustryWriteAPISchema: z.ZodType<IndustryWriteAPI> = NeoNodeWriteAPISchemaObject.extend({
  name: z.string().optional(),
}).passthrough();
